import React from 'react';
import CrmCommunicationTicketsList from './CrmCommunicationTicketsList';
import { CRM_COMM_PAGE_MY_ACQUISITION_BY_STATE } from '../../utils/crmCommunicationTableColumns';

export const CRM_COMM_MASK_MY_ACQUISITION_BY_STATE = 'cust033';

/** Moje akvizície → Podľa stavu (cust033). */
export default function CustomerMyAcquisitionByStateList(props) {
  return (
    <CrmCommunicationTicketsList
      {...props}
      crmTicketsLayout
      stateListLayout
      types="acquisition"
      mineOnlyDefault={false}
      traderBusinessScope
      listPageKey={CRM_COMM_PAGE_MY_ACQUISITION_BY_STATE}
      maskCode={CRM_COMM_MASK_MY_ACQUISITION_BY_STATE}
    />
  );
}
